import { useEffect } from "react";
import { useBlocker } from "react-router";

/**
 * Asks the user to confirm before leaving the page while `when` is true,
 * including browser back/forward, reload and tab close. Needs a data router (RouterProvider).
 */
export function usePrompt(message: string, when: boolean): void {
    const blocker = useBlocker(when);

    // useBlocker only covers in-app navigation; history v5's block() also guarded reload/close
    useEffect(() => {
        if (!when) {
            return;
        }

        const onBeforeUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            event.returnValue = "";
        };

        window.addEventListener("beforeunload", onBeforeUnload);
        return () => window.removeEventListener("beforeunload", onBeforeUnload);
    }, [when]);

    useEffect(() => {
        if (blocker.state !== "blocked") {
            return;
        }

        if (window.confirm(message)) {
            blocker.proceed();
        } else {
            blocker.reset();
        }
    }, [blocker, message]);
}
